import i18next from 'i18next';

function toolTranslations(
  id: string,
  label: string,
  options?: { reasoning?: string; output?: string; noop?: string },
): Record<string, string> {
  return {
    [id]: label,
    [`${id}Reasoning`]: options?.reasoning ?? label,
    [`${id}Output`]: options?.output ?? `Completed: ${label}`,
    [`${id}Noop`]: options?.noop ?? `No results: ${label}`,
    [`${id}Error`]: `Error: ${label}`,
  };
}

export default function initI18n(): void {
  i18next.addResourceBundle('en', 'ai-tool', {
    ...toolTranslations('spawnAgent', 'Spawn agent', {
      reasoning: 'Spawning agent',
      output: 'Spawned agent · job {{jobState}}{{jobErrorSuffix}}',
    }),
    ...toolTranslations('switchAgent', 'Switch agent', {
      reasoning: 'Switching agent',
      output: 'Switched agent',
    }),
  });
}
